module.exports = __webpack_public_path__ + "img/41.1f7ada8f.jpg";